export function remToPx(rem) {
  return rem * parseFloat(window.getComputedStyle(document.documentElement, null).fontSize)
}
